let hasHadFocusSince = 0;

if (typeof self.document !== 'undefined') {
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function addEventListener called at module scope is not allowed. This may cause unwanted side effects. */
    self.document.addEventListener('visibilitychange', () => {
        hasHadFocusSince = isDocumentVisible() ? new Date().getTime() : Number.MAX_VALUE;
    });
}

export function hasUserWindowHadFocusSince(time: number): boolean {
    return time >= hasHadFocusSince;
}

export function isDocumentVisible(): boolean {
    return self.document?.visibilityState == 'visible';
}
